export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: unknown; output: unknown; }
};

export type Admin = {
  adminManagement: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  fullName: Scalars['String']['output'];
  gameCreation: Scalars['Boolean']['output'];
  globalModulesAccess: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isSuperAdmin: Scalars['Boolean']['output'];
  memberships?: Maybe<Array<AdminMembership>>;
  permissions?: Maybe<AdminPermissionsType>;
  pii: Scalars['Boolean']['output'];
  roles?: Maybe<Array<AdminRole>>;
  updatedAt: Scalars['String']['output'];
};

export type AdminGetSurveyLink = {
  gameId: Scalars['String']['input'];
  surveyID: Scalars['String']['input'];
};

export type AdminMembership = {
  adminId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  gameId: Scalars['String']['output'];
  roleDetails?: Maybe<Array<AdminRole>>;
  roles: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type AdminPermissionsType = {
  allGames: Array<Scalars['String']['output']>;
  perGame?: Maybe<Scalars['JSON']['output']>;
};

export type AdminRole = {
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type AdminSearchSurveys = {
  gameId: Scalars['String']['input'];
  searchTerm: Scalars['String']['input'];
};

export type AdminValidateSurvey = {
  gameId: Scalars['String']['input'];
  surveyID: Scalars['String']['input'];
};

export type AfterGameSurvey = {
  isAutoSend: Scalars['Boolean']['output'];
  lastValidated?: Maybe<Scalars['String']['output']>;
  link: Scalars['String']['output'];
  sendDate: Scalars['String']['output'];
  surveyID: Scalars['String']['output'];
  surveyName?: Maybe<Scalars['String']['output']>;
  validationStatus?: Maybe<ValidationStatus>;
};

export type AfterGameSurveyInput = {
  isAutoSend: Scalars['Boolean']['input'];
  lastValidated?: InputMaybe<Scalars['String']['input']>;
  link: Scalars['String']['input'];
  sendDate: Scalars['String']['input'];
  surveyID: Scalars['String']['input'];
  surveyName?: InputMaybe<Scalars['String']['input']>;
  validationStatus?: InputMaybe<ValidationStatus>;
};

export type AnalyticsFilterInput = {
  childCategory?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  registrationStatus?: InputMaybe<Scalars['String']['input']>;
  tagType?: InputMaybe<Scalars['String']['input']>;
  teamType?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsGameResult = {
  count: Scalars['Int']['output'];
  filterToken: Scalars['String']['output'];
  metric: AnalyticsMetric;
  updatedAt: Scalars['String']['output'];
};

export type AnalyticsHour2Result = {
  count: Scalars['Int']['output'];
  filterToken: Scalars['String']['output'];
  hour2Bucket: Scalars['String']['output'];
  metric: AnalyticsMetric;
  updatedAt: Scalars['String']['output'];
};

export type AnalyticsLocationResult = {
  count: Scalars['Int']['output'];
  filterToken: Scalars['String']['output'];
  locationId: Scalars['ID']['output'];
  metric: AnalyticsMetric;
  updatedAt: Scalars['String']['output'];
};

export enum AnalyticsMetric {
  AdultInactivity = 'ADULT_INACTIVITY',
  ChildInactivity = 'CHILD_INACTIVITY',
  Disability = 'DISABILITY',
  Join = 'JOIN',
  MedicalCondition = 'MEDICAL_CONDITION',
  NonWhite = 'NON_WHITE',
  Participation = 'PARTICIPATION',
  ParticipationClosing = 'PARTICIPATION_CLOSING',
  ParticipationOneYear = 'PARTICIPATION_ONE_YEAR',
  ParticipationSixMonths = 'PARTICIPATION_SIX_MONTHS',
  Reg = 'REG',
  Swp = 'SWP'
}

export enum AnalyticsNamedCounterName {
  Anonymised = 'ANONYMISED',
  BeatboxVisited = 'BEATBOX_VISITED',
  Cards = 'CARDS',
  Consent = 'CONSENT',
  Devices = 'DEVICES',
  Dow = 'DOW',
  /** @deprecated Use JOIN. This name reads the JOIN counter. */
  EverJoined = 'EVER_JOINED',
  Join = 'JOIN',
  Mileage = 'MILEAGE',
  Movement = 'MOVEMENT',
  Reg = 'REG',
  Surveys = 'SURVEYS',
  SwpTagType = 'SWP_TAG_TYPE'
}

export type AnalyticsNamedCounterResult = {
  bucketName: Scalars['String']['output'];
  counterName: AnalyticsNamedCounterName;
  updatedAt: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type AnalyticsZoneResult = {
  count: Scalars['Int']['output'];
  filterToken: Scalars['String']['output'];
  metric: AnalyticsMetric;
  updatedAt: Scalars['String']['output'];
  zoneId: Scalars['String']['output'];
};

/** Types of answers */
export enum AnswerType {
  Pnts = 'PNTS',
  No = 'no',
  Yes = 'yes'
}

/** Player app variant for this game */
export enum AppVariant {
  Bts = 'bts',
  Roots = 'roots'
}

export type ApproveMappingLayerInput = {
  gameId: Scalars['String']['input'];
  layer: MappingLayer;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Result of assign ranges operation */
export type AssignRangesResult = {
  skippedCount: Scalars['Float']['output'];
  skippedRanges: Array<SkippedRange>;
  success: Scalars['Boolean']['output'];
  successCount: Scalars['Float']['output'];
};

export type AssignSubranges = {
  gameId: Scalars['String']['input'];
};

export type BulkChangeSubranges = {
  gameId: Scalars['String']['input'];
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignAnalytics = {
  delivered: Scalars['Int']['output'];
  likes: Scalars['Int']['output'];
  openedByPush: Scalars['Int']['output'];
  read: Scalars['Int']['output'];
};

export type CampaignRecord = {
  /** Campaign analytics. Resolved on demand. */
  analytics?: Maybe<CampaignAnalytics>;
  /** Author of this team message. Resolved on demand. */
  author?: Maybe<PlayerInfo>;
  /** Team message specific */
  authorId?: Maybe<Scalars['String']['output']>;
  campaignId: Scalars['String']['output'];
  category?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  /** Related game, global message if its empty */
  gameId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Total unique players received push notifications */
  pushPlayersCount?: Maybe<Scalars['Float']['output']>;
  /** Total push notifications sent */
  pushTotalCount?: Maybe<Scalars['Float']['output']>;
  scheduledTime?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<MessageSegment>;
  status?: Maybe<MessageCampaignStatus>;
  /** Team associated with this campaign. Resolved on demand. */
  team?: Maybe<Team>;
  /** Team message specific */
  teamId?: Maybe<Scalars['String']['output']>;
};

export type CancelCampaignInput = {
  campaignId: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
};

/** Card order status */
export enum CardOrderStatus {
  Delivered = 'delivered',
  Draft = 'draft',
  Ordered = 'ordered',
  Shipped = 'shipped'
}

export type ChangeAdminPasswordInput = {
  id: Scalars['String']['input'];
  password: Scalars['String']['input'];
  permanent?: Scalars['Boolean']['input'];
};

export type ChangePasswordInput = {
  password: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};

export type ClosingSurvey = {
  isAutoSend: Scalars['Boolean']['output'];
  lastValidated?: Maybe<Scalars['String']['output']>;
  link: Scalars['String']['output'];
  sendDaysBeforeEnd?: Maybe<Array<Scalars['Int']['output']>>;
  shownFromDate: Scalars['String']['output'];
  surveyID: Scalars['String']['output'];
  surveyName?: Maybe<Scalars['String']['output']>;
  validationStatus?: Maybe<ValidationStatus>;
};

export type ClosingSurveyInput = {
  isAutoSend: Scalars['Boolean']['input'];
  lastValidated?: InputMaybe<Scalars['String']['input']>;
  link: Scalars['String']['input'];
  sendDaysBeforeEnd?: InputMaybe<Array<Scalars['Int']['input']>>;
  shownFromDate: Scalars['String']['input'];
  surveyID: Scalars['String']['input'];
  surveyName?: InputMaybe<Scalars['String']['input']>;
  validationStatus?: InputMaybe<ValidationStatus>;
};

/** Details of a conflicting game */
export type ConflictingGame = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CreateAdminInput = {
  adminManagement?: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  gameCreation?: Scalars['Boolean']['input'];
  globalModulesAccess?: Scalars['Boolean']['input'];
  isSuperAdmin?: Scalars['Boolean']['input'];
  pii?: Scalars['Boolean']['input'];
  sendWelcomeEmail?: Scalars['Boolean']['input'];
  temporaryPassword: Scalars['String']['input'];
};

export type CreateAdminRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  permissions: Array<Scalars['String']['input']>;
};

export type CreateCampaignInput = {
  content: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
  playerCategory: Scalars['String']['input'];
  segment: MessageSegment;
  sendTime?: InputMaybe<Scalars['String']['input']>;
  sentImmediately: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
};

/** Create Game Info */
export type CreateGameInfoInput = {
  anticipation?: InputMaybe<Scalars['String']['input']>;
  anticipationStartsAt: Scalars['String']['input'];
  appOnlyGame?: InputMaybe<Scalars['Boolean']['input']>;
  appVariant?: InputMaybe<AppVariant>;
  boundingBox?: InputMaybe<Scalars['String']['input']>;
  endCountdownDays?: InputMaybe<Scalars['Float']['input']>;
  endsAt: Scalars['String']['input'];
  helpWidget: HelpWidget;
  hideOnLanding?: InputMaybe<Scalars['Boolean']['input']>;
  isMobileGame?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  region?: InputMaybe<GameRegion>;
  restrictAtDays?: InputMaybe<Scalars['Float']['input']>;
  sanityID?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<SettingsInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  startsAt: Scalars['String']['input'];
  status: GameStatus;
  surveys?: InputMaybe<SurveyOptionsInput>;
  sustainEndsAt: Scalars['String']['input'];
  teamsStartsAt: Scalars['String']['input'];
  type: GameType;
};

/** Create Game */
export type CreateGameInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  info: CreateGameInfoInput;
};

/** Create Group */
export type CreateGroupInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gameId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** A reply names only its parent and inherits the rest. A new thread names its kind; a review thread also names its location and review type. */
export type CreateMappingCommentInput = {
  content: Scalars['String']['input'];
  coordinates?: InputMaybe<MappingCoordinatesInput>;
  gameId: Scalars['String']['input'];
  kind?: InputMaybe<MappingCommentKind>;
  layer?: InputMaybe<MappingLayer>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  parentCommentId?: InputMaybe<Scalars['String']['input']>;
  /** Set from the reviewer's own type when a reviewer writes */
  reviewType?: InputMaybe<MappingReviewType>;
};

export type CreateMappingLocationInput = {
  accessible?: InputMaybe<Scalars['Boolean']['input']>;
  beatBoxNumber?: InputMaybe<Scalars['Int']['input']>;
  candidates?: InputMaybe<Array<MappingLocationCandidateInput>>;
  coordinates?: InputMaybe<MappingCoordinatesInput>;
  description: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
  gemType?: InputMaybe<GemType>;
  geo?: InputMaybe<MappingLocationGeoInput>;
  isBonus?: InputMaybe<Scalars['Boolean']['input']>;
  mappingNotes?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  ownerName?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  selectedCandidateId?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  type: LocationTypes;
};

export type CreateMappingReviewInput = {
  gameId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  riskAssessment?: InputMaybe<Scalars['JSON']['input']>;
  type: MappingReviewType;
};

export type CreateMembershipInput = {
  adminId: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
  roles: Array<Scalars['String']['input']>;
};

export type DataExportJob = {
  createdAt: Scalars['String']['output'];
  downloadUrl?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  expiredAt: Scalars['Float']['output'];
  exportType: DataExportType;
  filename?: Maybe<Scalars['String']['output']>;
  gameId: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  s3Path: Scalars['String']['output'];
  status: DataExportJobStatus;
  updatedAt: Scalars['String']['output'];
};

export enum DataExportJobStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY',
  Running = 'RUNNING'
}

export enum DataExportType {
  EmailExtractor = 'emailExtractor',
  PartnerConsent = 'partnerConsent',
  SecondaryTeamsLeaderboard = 'secondaryTeamsLeaderboard'
}

export type DeleteEvent = {
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type DeleteEventPoint = {
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** Delete Game */
export type DeleteGameInput = {
  id: Scalars['String']['input'];
};

export type DeleteLeaderboard = {
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type DeleteMembershipInput = {
  adminId: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
};

export type EnrichedPrizeDrawWinner = {
  createdAt: Scalars['String']['output'];
  drawId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  gameId: Scalars['String']['output'];
  info: PlayerInfo;
  parentId?: Maybe<Scalars['String']['output']>;
  parentInfo?: Maybe<PlayerInfo>;
  parentProfile?: Maybe<PlayerProfile>;
  playerId: Scalars['String']['output'];
  profile: PlayerProfile;
  /** Reason for the failed status */
  reason?: Maybe<Scalars['String']['output']>;
  /** Reason for the rejected status */
  rejectedReason?: Maybe<Scalars['String']['output']>;
  status: PrizeDrawWinnerStatus;
  swipeId?: Maybe<Scalars['String']['output']>;
};

export type Event = {
  /** Override customLocations and locationCategory */
  allBeatBoxes?: Maybe<Scalars['Boolean']['output']>;
  /** Override timing array */
  allDay?: Maybe<Scalars['Boolean']['output']>;
  customLocationIds?: Maybe<Array<Scalars['String']['output']>>;
  description: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  gameId: Scalars['String']['output'];
  groupIds?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  /** Set's Sanity integration. */
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  sanityID?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['String']['output'];
  timing?: Maybe<Array<Timing>>;
  weekDay: Array<Scalars['Int']['output']>;
};

/** Create Game Event */
export type EventCreateInput = {
  /** Override customLocations and locationCategory */
  allBeatBoxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Override timing array */
  allDay?: InputMaybe<Scalars['Boolean']['input']>;
  customLocationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** Set's Sanity integration. */
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['String']['input'];
  timing?: InputMaybe<Array<TimingInput>>;
  weekDay: Array<Scalars['Int']['input']>;
};

export type EventPoint = {
  endDate: Scalars['String']['output'];
  eventId: Scalars['String']['output'];
  gameId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  points: Scalars['Int']['output'];
  startDate: Scalars['String']['output'];
};

/** Update Game Event */
export type EventUpdateInput = {
  /** Override customLocations and locationCategory */
  allBeatBoxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Override timing array */
  allDay?: InputMaybe<Scalars['Boolean']['input']>;
  customLocationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  gameId: Scalars['String']['input'];
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  /** Set's Sanity integration. */
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  timing?: InputMaybe<Array<TimingInput>>;
  weekDay?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FindByTag = {
  gameId?: InputMaybe<Scalars['String']['input']>;
  tagNumber: Scalars['Int']['input'];
};

export type FindEventPoints = {
  eventId: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
};

export type FindFamilyPlayersInput = {
  isChild?: InputMaybe<Scalars['Boolean']['input']>;
  parentId: Scalars['String']['input'];
};

export type FindGroupElements = {
  gameId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
};

export type FindInactiveTagInput = {
  playerId: Scalars['String']['input'];
};

export type FindMembershipsInput = {
  adminId?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
};

export type FindSwipeByDateRange = {
  gameId: Scalars['String']['input'];
};

export type FindTagSubranges = {
  filter?: InputMaybe<SubrangeFilter>;
  gameId: Scalars['String']['input'];
};

export type FindTeamsInput = {
  gameId: Scalars['String']['input'];
  includeSubTeams?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Admin Update player */
export type FullUpdatePlayerInput = {
  ageGroup?: InputMaybe<Scalars['String']['input']>;
  /** Set Cognito email_verified on the player user pool user */
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  info?: InputMaybe<PlayerInfoInput>;
  profile?: InputMaybe<PlayerProfileInput>;
};

export type Game = {
  /** @deprecated Use liveTotals. Kept for released mobile clients. */
  counter: GameCounter;
  id: Scalars['String']['output'];
  info: GameInfo;
  leaderboards: Array<GameLeaderboard>;
  liveTotals: GameLiveTotals;
  locations: Array<Location>;
  tagRanges: Array<GameTagRange>;
  tagSubranges: Array<GameTagSubrange>;
  teams: Array<Team>;
};

export type GameCounter = {
  registeredDevices: Scalars['Int']['output'];
  registeredPlayers: Scalars['Int']['output'];
  swipesCount: Scalars['Int']['output'];
  totalMiles: Scalars['Float']['output'];
  totalPlayers: Scalars['Int']['output'];
};

export type GameInfo = {
  anticipation?: Maybe<Scalars['String']['output']>;
  anticipationStartsAt: Scalars['String']['output'];
  appOnlyGame?: Maybe<Scalars['Boolean']['output']>;
  appVariant?: Maybe<AppVariant>;
  boundingBox?: Maybe<Scalars['String']['output']>;
  /** Show end countdown X days before game ends. */
  endCountdownDays?: Maybe<Scalars['Float']['output']>;
  endsAt: Scalars['String']['output'];
  helpWidget: HelpWidget;
  hideOnLanding?: Maybe<Scalars['Boolean']['output']>;
  isMobileGame?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  /** Set when game is finished (not longer supported) */
  originalSlug?: Maybe<Scalars['String']['output']>;
  region?: Maybe<GameRegion>;
  /** Close joining and creating new teams ant X day before game ends. */
  restrictAtDays?: Maybe<Scalars['Float']['output']>;
  settings: Settings;
  slug: Scalars['String']['output'];
  startsAt: Scalars['String']['output'];
  status: GameStatus;
  surveys?: Maybe<SurveyOptions>;
  sustainEndsAt: Scalars['String']['output'];
  targetedEmails?: Maybe<TargetedEmailsSetting>;
  teamsStartsAt: Scalars['String']['output'];
  type: GameType;
};

export type GameLeaderboard = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  teamIds?: Maybe<Array<Scalars['String']['output']>>;
  teamTypes?: Maybe<Array<TeamTypes>>;
};

/** Create Game Leaderboard */
export type GameLeaderboardCreateInput = {
  gameId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  teamIds?: InputMaybe<Array<Scalars['String']['input']>>;
  teamTypes?: InputMaybe<Array<TeamTypes>>;
};

/** Update Game Leaderboard */
export type GameLeaderboardUpdateInput = {
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  teamIds?: InputMaybe<Array<Scalars['String']['input']>>;
  teamTypes?: InputMaybe<Array<TeamTypes>>;
};

export type GameLiveTotals = {
  /** @deprecated Use totalPlayers. This field reads the JOIN counter. */
  everJoinedPlayers: Scalars['Int']['output'];
  registeredPlayers: Scalars['Int']['output'];
  totalMiles: Scalars['Float']['output'];
  totalPlayers: Scalars['Int']['output'];
};

export type GameMapDataset = {
  audience: MapDatasetAudience;
  dataset?: Maybe<MapDataset>;
  datasetId: Scalars['String']['output'];
  gameId: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  styleOverride?: Maybe<MapDatasetStyle>;
  visibleByDefault: Scalars['Boolean']['output'];
};

export enum GameRegion {
  England = 'England',
  Ireland = 'Ireland',
  Scotland = 'Scotland'
}

export type GameResource = {
  available: Scalars['Boolean']['output'];
  key: GameResourceKey;
  title: Scalars['String']['output'];
  unavailableReason?: Maybe<Scalars['String']['output']>;
};

export enum GameResourceKey {
  DistributionBoxLetter = 'distributionBoxLetter',
  SchoolBoxLetter = 'schoolBoxLetter',
  TeacherLetter = 'teacherLetter'
}

/** Game lifecycle status */
export enum GameStatus {
  Anticipation = 'anticipation',
  Draft = 'draft',
  Finished = 'finished',
  Live = 'live',
  Sustain = 'sustain'
}

export type GameTagRange = {
  from: Scalars['Int']['output'];
  gameId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  to: Scalars['Int']['output'];
};

/** Create Game Tag Range */
export type GameTagRangeCreateInput = {
  from: Scalars['Int']['input'];
  gameId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Int']['input'];
};

/** Delete Game Tag Range */
export type GameTagRangeDeleteInput = {
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** Update Game Tag Range */
export type GameTagRangeUpdateInput = {
  from: Scalars['Int']['input'];
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  to: Scalars['Int']['input'];
};

export type GameTagSubrange = {
  amount: Scalars['Int']['output'];
  connectionId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distributionPointId?: Maybe<Scalars['String']['output']>;
  from: Scalars['Int']['output'];
  gameId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isApproved: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  reassignExistingTeams?: Maybe<Scalars['Boolean']['output']>;
  reassignTeams?: Maybe<Scalars['Boolean']['output']>;
  tagType: TagsTypes;
  team?: Maybe<Team>;
  to: Scalars['Int']['output'];
  type: SubrangesTypes;
};

/** Create game tag sub-range */
export type GameTagSubrangeCreateInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  connectionId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  distributionPointId?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  gameId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  reassignExistingTeams?: InputMaybe<Scalars['Boolean']['input']>;
  reassignTeams?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
  type: SubrangesTypes;
};

/** Delete Game Tag Subrange */
export type GameTagSubrangeDeleteInput = {
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** Update game tag sub-range */
export type GameTagSubrangeUpdateInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  connectionId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  distributionPointId?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  reassignExistingTeams?: InputMaybe<Scalars['Boolean']['input']>;
  reassignTeams?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<SubrangesTypes>;
};

/** Game type depending on the game size */
export enum GameType {
  Classic = 'classic',
  Compact = 'compact'
}

export type GemRoute = {
  gameId: Scalars['String']['output'];
  gemType: GemType;
  id: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  locationSlug?: Maybe<Scalars['String']['output']>;
  playerId: Scalars['String']['output'];
  points: Scalars['Int']['output'];
  swipeId?: Maybe<Scalars['String']['output']>;
  tagNumber: Scalars['Int']['output'];
  timestamp: Scalars['String']['output'];
};

/** Types for gems. Valid only form LocationTypes === 'gem' */
export enum GemType {
  Amber = 'amber',
  Cyan = 'cyan',
  Emerald = 'emerald',
  Hidden = 'hidden',
  Purple = 'purple',
  Ruby = 'ruby',
  Unset = 'unset'
}

export type GenerateGameResourcePdfInput = {
  gameId: Scalars['String']['input'];
  key: GameResourceKey;
  templateId?: Scalars['String']['input'];
};

export type GetEvent = {
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type GetForPaginatedListInput = {
  gameId: Scalars['String']['input'];
  ids: Array<Scalars['String']['input']>;
};

export type GetGroup = {
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type GetLocationInput = {
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type GetPlayerLeaderboardsInput = {
  gameId: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
  secondaryTeamId?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  type: LeaderboardPointType;
};

export type GetTeamInput = {
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type Group = {
  color: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  gameId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GroupElement = {
  gameId: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
};

/** Create / Delete Group element */
export type GroupElementInput = {
  gameId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};

/** Game Freshdesk widget */
export enum HelpWidget {
  Standard = 'standard',
  StandardAndMobile = 'standardAndMobile',
  StandardAndWelsh = 'standardAndWelsh'
}

export type ImdDecileAggregate = {
  decile: Scalars['Int']['output'];
  indexOfPenetration: Scalars['Float']['output'];
  totalPlayers: Scalars['Int']['output'];
  totalPlayersPercent: Scalars['Float']['output'];
  totalPopulation: Scalars['Int']['output'];
  totalPopulationPercent: Scalars['Float']['output'];
};

export type ImdDecileAggregates = {
  deciles: Array<ImdDecileAggregate>;
  totalPlayers: Scalars['Int']['output'];
  totalPopulation: Scalars['Int']['output'];
  unmatchedZoneCount: Scalars['Int']['output'];
};

export type ImportMapDatasetInput = {
  attribution?: InputMaybe<Scalars['String']['input']>;
  category: MapDatasetCategory;
  defaultStyle?: InputMaybe<MapDatasetStyleInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  serviceUrl?: InputMaybe<Scalars['String']['input']>;
  sourceKind: MapDatasetSourceKind;
  stagingKey?: InputMaybe<Scalars['String']['input']>;
};

export type InactiveTag = {
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  playerId: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  tagNumber: Scalars['Int']['output'];
};

/** Create Inactive Tag */
export type InactiveTagCreateInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  playerId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  tagNumber: Scalars['Int']['input'];
};

/** Delete Inactive Tag */
export type InactiveTagDeleteInput = {
  id: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};

export type IncrementPlayerPoint = {
  extra: Scalars['Float']['input'];
  id: Scalars['String']['input'];
};

/** Installer Update Location */
export type InstallerLocationUpdateInput = {
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

export type InviteMappingReviewerInput = {
  allowedReviewType: MappingReviewerType;
  email: Scalars['String']['input'];
  expiresAt: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type IsGameTagRangeAvailable = {
  from: Scalars['Int']['input'];
  gameId: Scalars['String']['input'];
  to: Scalars['Int']['input'];
};

export type IsTagSubrangesAvailable = {
  from: Scalars['Int']['input'];
  to: Scalars['Int']['input'];
};

export type JoinTeamInput = {
  playerId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};

/** A nearby OS NGD street light (lamppost) candidate */
export type LamppostCandidate = {
  /** Straight-line metres from the rough Beat Box point */
  distanceMeters: Scalars['Float']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  /** OS NGD OSID (GUID) */
  osid: Scalars['String']['output'];
};

export enum LeaderboardPointType {
  Gem = 'gem',
  Swipe = 'swipe'
}

export type LeaderboardsResponse = {
  data: Array<LeaderboardsResults>;
  rank: Scalars['String']['output'];
};

export type LeaderboardsResults = {
  amount: Scalars['Float']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  marked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Float']['output'];
};

export type LinkMapDatasetInput = {
  audience?: InputMaybe<MapDatasetAudience>;
  datasetId: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
  visibleByDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Location = {
  accessible?: Maybe<Scalars['Boolean']['output']>;
  beatBoxNumber?: Maybe<Scalars['Int']['output']>;
  /** Admin id or player id of the creator */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** True when a player created this location */
  createdByPlayer?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum points set in event on request time */
  currentPoints: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  gameId: Scalars['String']['output'];
  gemType?: Maybe<GemType>;
  geo?: Maybe<LocationGeo>;
  id: Scalars['String']['output'];
  /** True when this Beat Box is a Bonus Beat Box. Resolved from stored isMobile. */
  isBonus?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isBonus. Kept for released clients. */
  isMobile?: Maybe<Scalars['Boolean']['output']>;
  /** True when the signed-in player created this location */
  isOwnedByMe?: Maybe<Scalars['Boolean']['output']>;
  isVisible: Scalars['Boolean']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  /** Friendly/display name */
  name?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  /** Default points to be gain in location */
  points: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  stats?: Maybe<LocationStats>;
  status: LocationStatus;
  type: LocationTypes;
  /** Server-computed what3words address */
  what3words?: Maybe<Scalars['String']['output']>;
};

export type LocationGeo = {
  /** Persisted ORS isochrone snapshot { geometry, profile, range, rangeType, sourceCoord, computedAt } */
  isochrone?: Maybe<Scalars['JSON']['output']>;
  /** Persisted OS NGD lamppost snapshot { selectedOsid, searchRadiusMeters, sourceCoord, candidates } or null */
  lamppost?: Maybe<Scalars['JSON']['output']>;
  /** Persisted nearest-Beat-Box snapshot { nearestBeatBoxId, distanceMeters, routeGeometry, computedAt } or null */
  nearest?: Maybe<Scalars['JSON']['output']>;
};

/** Server-computed Beat Box placement assessment (live preview) */
export type LocationPlacementAssessment = {
  /** Final (snapped) [lng, lat] */
  coord: Array<Scalars['Float']['output']>;
  isTooClose: Scalars['Boolean']['output'];
  isochrone?: Maybe<Scalars['JSON']['output']>;
  nearest?: Maybe<Scalars['JSON']['output']>;
};

export type LocationStats = {
  batteryLevel?: Maybe<Scalars['String']['output']>;
  deviceID?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  reported?: Maybe<Scalars['String']['output']>;
};

/** Status of each location. Handle soft deletes */
export enum LocationStatus {
  Active = 'active',
  Removed = 'removed'
}

/** Types of map locations */
export enum LocationTypes {
  Poi = 'POI',
  BeatBox = 'beatBox',
  DistributionPoint = 'distributionPoint',
  Gem = 'gem',
  School = 'school'
}

export type MapDataset = {
  bbox: Array<Scalars['Float']['output']>;
  category: MapDatasetCategory;
  defaultStyle: MapDatasetStyle;
  description?: Maybe<Scalars['String']['output']>;
  featureCount: Scalars['Int']['output'];
  featuresUrl: Scalars['String']['output'];
  geometryType: MapDatasetGeometryType;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  source: MapDatasetSource;
  updatedAt: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export enum MapDatasetAudience {
  Players = 'players',
  Reference = 'reference'
}

export enum MapDatasetCategory {
  ActiveTravel = 'active_travel',
  Boundary = 'boundary',
  GreenSpace = 'green_space',
  Infrastructure = 'infrastructure',
  Other = 'other'
}

export enum MapDatasetGeometryType {
  Line = 'line',
  Mixed = 'mixed',
  Point = 'point',
  Polygon = 'polygon'
}

export type MapDatasetSource = {
  attribution?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  kind: MapDatasetSourceKind;
  serviceUrl?: Maybe<Scalars['String']['output']>;
};

export enum MapDatasetSourceKind {
  Service = 'service',
  Upload = 'upload'
}

export type MapDatasetStyle = {
  color: Scalars['String']['output'];
  lineWidth: Scalars['Float']['output'];
  opacity: Scalars['Float']['output'];
};

export type MapDatasetStyleInput = {
  color: Scalars['String']['input'];
  lineWidth: Scalars['Float']['input'];
  opacity: Scalars['Float']['input'];
};

export type MapDatasetUploadTarget = {
  stagingKey: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type MapDatasetUploadTargetInput = {
  filename: Scalars['String']['input'];
};

/** Every comment in a game: review threads on a location and queries about the map, a layer, a location or a point. */
export type MappingComment = {
  author: MappingPerson;
  authorRole: MappingCommentAuthorRole;
  content: Scalars['String']['output'];
  coordinates?: Maybe<MappingCoordinates>;
  createdAt: Scalars['String']['output'];
  gameId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  kind: MappingCommentKind;
  /** Absent on a query about the map as a whole */
  layer?: Maybe<MappingLayer>;
  locationId?: Maybe<Scalars['String']['output']>;
  parentCommentId?: Maybe<Scalars['String']['output']>;
  reactions?: Maybe<Array<MappingCommentReaction>>;
  resolvedAt?: Maybe<Scalars['String']['output']>;
  /** The review a review thread belongs to, or the reviewer a query is with. Replies inherit it. */
  reviewType: MappingReviewType;
  status: MappingCommentStatus;
  updatedAt: Scalars['String']['output'];
};

export enum MappingCommentAuthorRole {
  Mapper = 'mapper',
  Reviewer = 'reviewer'
}

export enum MappingCommentKind {
  Query = 'query',
  Review = 'review'
}

export type MappingCommentReaction = {
  actors: Array<MappingPerson>;
  emoji: Scalars['String']['output'];
};

export enum MappingCommentStatus {
  Pending = 'pending',
  Resolved = 'resolved'
}

export type MappingCoordinates = {
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type MappingCoordinatesInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type MappingHistory = {
  action: MappingHistoryAction;
  actor: MappingPerson;
  createdAt: Scalars['String']['output'];
  gameId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  metadata: Scalars['JSON']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum MappingHistoryAction {
  CommentAddressed = 'comment_addressed',
  LocationApproved = 'location_approved',
  LocationCreated = 'location_created',
  LocationPublished = 'location_published',
  LocationSubmittedForReview = 'location_submitted_for_review',
  LocationUnpublished = 'location_unpublished',
  LocationUpdated = 'location_updated',
  ReviewChangesRequested = 'review_changes_requested',
  ReviewPassed = 'review_passed'
}

export enum MappingLayer {
  BeatBoxes = 'beat_boxes',
  BonusBeatBoxes = 'bonus_beat_boxes',
  DistributionPoints = 'distribution_points',
  Gems = 'gems',
  Poi = 'poi',
  Schools = 'schools'
}

export type MappingLayerReview = {
  approvedAt?: Maybe<Scalars['String']['output']>;
  approvedCount: Scalars['Int']['output'];
  changesRequestedCount: Scalars['Int']['output'];
  gameId: Scalars['String']['output'];
  layer: MappingLayer;
  locationCount: Scalars['Int']['output'];
  openQueryCount: Scalars['Int']['output'];
  pendingCount: Scalars['Int']['output'];
  /** Also counted in pendingCount: the reviewer has the move */
  respondedCount: Scalars['Int']['output'];
  status: MappingLayerReviewStatus;
  totalCount: Scalars['Int']['output'];
  type: MappingReviewType;
};

export enum MappingLayerReviewStatus {
  Approved = 'approved',
  InReview = 'in_review'
}

export type MappingLayerSubmission = {
  createdCount: Scalars['Int']['output'];
  failedLocationIds: Array<Scalars['String']['output']>;
  layer: MappingLayerReview;
  skippedCount: Scalars['Int']['output'];
};

export type MappingLocation = {
  accessible?: Maybe<Scalars['Boolean']['output']>;
  beatBoxNumber?: Maybe<Scalars['Int']['output']>;
  candidates: Array<MappingLocationCandidate>;
  coordinates?: Maybe<MappingCoordinates>;
  createdAt: Scalars['String']['output'];
  /** Admin id or player id of the creator */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** True when a player created this location */
  createdByPlayer?: Maybe<Scalars['Boolean']['output']>;
  description: Scalars['String']['output'];
  gameId: Scalars['String']['output'];
  gemType?: Maybe<GemType>;
  geo?: Maybe<MappingLocationGeo>;
  id: Scalars['String']['output'];
  /** True when this Beat Box is a Bonus Beat Box. Resolved from stored isMobile. */
  isBonus?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isBonus. Kept for released clients. */
  isMobile?: Maybe<Scalars['Boolean']['output']>;
  /** Mapper notes about the placement, shown to reviewers */
  mappingNotes?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ownerName?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  /** Set by the first publish */
  publishedAt?: Maybe<Scalars['String']['output']>;
  /** Where the location is: Completed once published, else the furthest gate it has been sent to. Worked out from its reviews, never stored. */
  reviewStatus: MappingLocationReviewStatus;
  /** Reviews for this location. Resolved on demand. */
  reviews?: Maybe<Array<MappingReview>>;
  selectedCandidateId?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  type: LocationTypes;
  updatedAt: Scalars['String']['output'];
  /** Server-computed what3words address */
  what3words?: Maybe<Scalars['String']['output']>;
};

export type MappingLocationCandidate = {
  id: Scalars['String']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export type MappingLocationCandidateInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type MappingLocationGeo = {
  isochrone?: Maybe<Scalars['JSON']['output']>;
  lamppost?: Maybe<Scalars['JSON']['output']>;
  nearest?: Maybe<Scalars['JSON']['output']>;
};

export type MappingLocationGeoInput = {
  isochrone?: InputMaybe<Scalars['JSON']['input']>;
  lamppost?: InputMaybe<Scalars['JSON']['input']>;
  nearest?: InputMaybe<Scalars['JSON']['input']>;
};

export enum MappingLocationReviewStatus {
  ClientReview = 'client_review',
  Completed = 'completed',
  Draft = 'draft',
  HighwaysReview = 'highways_review',
  RiskAssessment = 'risk_assessment'
}

export enum MappingMapStage {
  ClientReview = 'client_review',
  Draft = 'draft',
  HighwaysReview = 'highways_review',
  Publish = 'publish',
  RiskAssessment = 'risk_assessment'
}

export type MappingPerson = {
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MappingPublishResult = {
  failedLocationIds: Array<Scalars['String']['output']>;
  publishedCount: Scalars['Int']['output'];
  skipped: Array<MappingPublishSkip>;
  /** Locations that were not eligible, or whose live row already matched. */
  skippedCount: Scalars['Int']['output'];
};

export type MappingPublishSkip = {
  locationId: Scalars['String']['output'];
  reason: MappingPublishSkipReason;
};

export enum MappingPublishSkipReason {
  AlreadyCurrent = 'already_current',
  LayerNotSignedOff = 'layer_not_signed_off',
  NoLayer = 'no_layer',
  NoPosition = 'no_position',
  NoPost = 'no_post',
  NoSlug = 'no_slug',
  ReviewsOutstanding = 'reviews_outstanding'
}

export type MappingReview = {
  approvedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  gameId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  riskAssessment?: Maybe<Scalars['JSON']['output']>;
  status: MappingReviewStatus;
  type: MappingReviewType;
  updatedAt: Scalars['String']['output'];
};

export enum MappingReviewStatus {
  Approved = 'approved',
  ChangesRequested = 'changes_requested',
  OwnershipRejected = 'ownership_rejected',
  Pending = 'pending',
  Responded = 'responded'
}

export enum MappingReviewType {
  ClientReview = 'client_review',
  HighwaysReview = 'highways_review',
  InstallerChanges = 'installer_changes',
  RiskAssessment = 'risk_assessment'
}

export type MappingReviewer = {
  allowedReviewType: MappingReviewerType;
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  gameId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  token: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum MappingReviewerType {
  ClientReview = 'client_review',
  HighwaysReview = 'highways_review'
}

/** One review round of the map: the Beat Boxes sent to a gate. Once passed it never reopens, and later changes are the mapper's authority for it. */
export type MappingRound = {
  createdAt: Scalars['String']['output'];
  gameId: Scalars['String']['output'];
  /** The Beat Boxes sent in this round, late arrivals included */
  locationIds: Array<Scalars['String']['output']>;
  openedAt: Scalars['String']['output'];
  openedBy?: Maybe<MappingPerson>;
  passedAt?: Maybe<Scalars['String']['output']>;
  passedBy?: Maybe<MappingPerson>;
  type: MappingReviewType;
  updatedAt: Scalars['String']['output'];
};

export type MappingStageSubmission = {
  createdCount: Scalars['Int']['output'];
  failedLayers: Array<MappingLayer>;
  failedLocationIds: Array<Scalars['String']['output']>;
  skippedCount: Scalars['Int']['output'];
  workflow: MappingWorkflow;
};

export type MappingWorkflow = {
  gameId: Scalars['String']['output'];
  rounds: Array<MappingRound>;
  /** The first round not yet passed, or Publish once all are */
  stage: MappingMapStage;
};

/** Delivery status for a game message campaign */
export enum MessageCampaignStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Failed = 'Failed',
  Scheduled = 'Scheduled',
  Sending = 'Sending'
}

/** Predefined audience for a game message campaign */
export enum MessageSegment {
  AllPlayers = 'AllPlayers',
  AppInstalled = 'AppInstalled',
  CommunityTeamPlayers = 'CommunityTeamPlayers',
  NoClosingSurvey = 'NoClosingSurvey',
  NoHealthSurvey = 'NoHealthSurvey',
  PlayersExceptTeamLeaders = 'PlayersExceptTeamLeaders',
  PlayersInATeam = 'PlayersInATeam',
  PlayersWithNoTeam = 'PlayersWithNoTeam',
  RunningCyclingTeamPlayers = 'RunningCyclingTeamPlayers',
  SchoolTeamPlayers = 'SchoolTeamPlayers',
  TeamLeaders = 'TeamLeaders'
}

export type MovePlayerInput = {
  playerId: Scalars['String']['input'];
  tagNumber: Scalars['Int']['input'];
};

export type MoveSmallTeamsInput = {
  gameId: Scalars['String']['input'];
  size: Scalars['Float']['input'];
};

export type Mutation = {
  assignTag: PlayerTag;
  assignTagSubrange: AssignRangesResult;
  bulkChangeTagSubrange: Scalars['Boolean']['output'];
  cancelCampaign: Scalars['Boolean']['output'];
  changeAdminPassword: Scalars['Boolean']['output'];
  changeMyPassword: Scalars['Boolean']['output'];
  changePlayerPassword: Scalars['Boolean']['output'];
  createAdmin: Admin;
  createCampaign: CampaignRecord;
  createEvent: Event;
  createGame: Game;
  createInactiveTag: InactiveTag;
  createLeaderboard: GameLeaderboard;
  createMappingComment: MappingComment;
  createMappingGroup: Group;
  createMappingGroupElement: GroupElement;
  createMappingLocation: MappingLocation;
  createMappingReview: MappingReview;
  createMembership: AdminMembership;
  createPrizeDraw: Scalars['String']['output'];
  createRole: AdminRole;
  createTagGlobal: TagGlobalRange;
  createTagRange: GameTagRange;
  createTagSubrange: GameTagSubrange;
  createTeam: Team;
  deleteAdmin: Scalars['Boolean']['output'];
  deleteCampaign: Scalars['Boolean']['output'];
  deleteEvent: Event;
  deleteEventPoint: Scalars['Boolean']['output'];
  deleteGame: Scalars['Boolean']['output'];
  deleteLeaderboard: Scalars['Boolean']['output'];
  deleteMapDataset: Scalars['Boolean']['output'];
  deleteMappingGroup: Scalars['Boolean']['output'];
  deleteMappingGroupElement: Scalars['Boolean']['output'];
  deleteMappingLocation: Scalars['Boolean']['output'];
  deleteMappingReviewer: Scalars['Boolean']['output'];
  deleteMembership: Scalars['Boolean']['output'];
  deletePlayer: Scalars['Boolean']['output'];
  deletePrizeDraw: Scalars['Boolean']['output'];
  deletePrizeDrawWinner: Scalars['Boolean']['output'];
  deleteRole: Scalars['Boolean']['output'];
  deleteTagGlobal: Scalars['Boolean']['output'];
  deleteTagRange: Scalars['Boolean']['output'];
  deleteTagSubrange: Scalars['Boolean']['output'];
  deleteTeam: Scalars['Boolean']['output'];
  drawMorePrizeDrawWinners: Scalars['Int']['output'];
  duplicateEvent: Event;
  generateGameResourcePdf: PdfGenerationJob;
  getSurveyLink?: Maybe<Scalars['String']['output']>;
  importMapDataset: MapDataset;
  installerUpdateLocation: Location;
  inviteMappingReviewer: MappingReviewer;
  isGameRangeAvailable: Scalars['Boolean']['output'];
  isSubrangeAvailable: SubrangeOverlapResult;
  joinTeam: Scalars['Boolean']['output'];
  kickFromGame: Scalars['Boolean']['output'];
  leaveTeam: Scalars['Boolean']['output'];
  linkMapDataset: GameMapDataset;
  mapDatasetUploadUrl: MapDatasetUploadTarget;
  markPrizeDrawWinnerAsFulfilled: Scalars['Boolean']['output'];
  moveSmallTeams: Scalars['Boolean']['output'];
  moveTag: Scalars['Boolean']['output'];
  /** Publishes every eligible location in a game. Ineligible ones are skipped with a reason, not failed. */
  publishMappingGame: MappingPublishResult;
  /** Marks a mapping location completed and writes it to the live Location table. */
  publishMappingLocation: MappingLocation;
  refreshMapDataset: MapDataset;
  removeInactiveTag: Scalars['Boolean']['output'];
  removePlayersFromGame: Scalars['Boolean']['output'];
  resolveMappingComment: MappingComment;
  reviewerApproveMappingLayer: MappingLayerReview;
  reviewerCreateMappingComment: MappingComment;
  reviewerResolveMappingComment: MappingComment;
  reviewerToggleMappingCommentReaction: MappingComment;
  reviewerUpdateMappingComment: MappingComment;
  reviewerUpdateMappingReview: MappingReview;
  searchSurveys: Array<SearchSurveyResult>;
  sendPrizeDrawWinnerEmail: Scalars['Boolean']['output'];
  startDataExport: DataExportJob;
  startOrsRuntime: OrsRuntimeStatus;
  stopOrsRuntime: OrsRuntimeStopResult;
  submitMappingLayerForReview: MappingLayerSubmission;
  /** Sends the map's Beat Boxes to a gate in one call: the next round, or late arrivals to the open one */
  submitMappingStage: MappingStageSubmission;
  toggleMappingCommentReaction: MappingComment;
  unlinkMapDataset: Scalars['Boolean']['output'];
  unlockApprovedTagSubrange: GameTagSubrange;
  updateAdmin: Admin;
  updateCampaign: Scalars['Boolean']['output'];
  updateEvent: Event;
  updateGame: Game;
  updateGameMapDataset: GameMapDataset;
  updateLeaderboard: GameLeaderboard;
  updateMapDataset: MapDataset;
  updateMappingComment: MappingComment;
  updateMappingGroup: Group;
  updateMappingLocation: MappingLocation;
  updateMappingReview: MappingReview;
  updateMembership: AdminMembership;
  updateMyProfile: Admin;
  updatePlayer: Player;
  updatePlayerPoints: Scalars['Boolean']['output'];
  updateRole: AdminRole;
  updateTagGlobal: TagGlobalRange;
  updateTagRange: GameTagRange;
  updateTagSubrange: GameTagSubrange;
  updateTeam: Team;
  validateSurvey: ValidateSurveyResponse;
};


export type MutationAssignTagArgs = {
  input: PlayerTagCreateInput;
};


export type MutationAssignTagSubrangeArgs = {
  input: AssignSubranges;
};


export type MutationBulkChangeTagSubrangeArgs = {
  input: BulkChangeSubranges;
};


export type MutationCancelCampaignArgs = {
  input: CancelCampaignInput;
};


export type MutationChangeAdminPasswordArgs = {
  input: ChangeAdminPasswordInput;
};


export type MutationChangeMyPasswordArgs = {
  password: Scalars['String']['input'];
};


export type MutationChangePlayerPasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationCreateAdminArgs = {
  input: CreateAdminInput;
};


export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput;
};


export type MutationCreateEventArgs = {
  input: EventCreateInput;
};


export type MutationCreateGameArgs = {
  input: CreateGameInput;
};


export type MutationCreateInactiveTagArgs = {
  input: InactiveTagCreateInput;
};


export type MutationCreateLeaderboardArgs = {
  input: GameLeaderboardCreateInput;
};


export type MutationCreateMappingCommentArgs = {
  input: CreateMappingCommentInput;
};


export type MutationCreateMappingGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateMappingGroupElementArgs = {
  input: GroupElementInput;
};


export type MutationCreateMappingLocationArgs = {
  input: CreateMappingLocationInput;
};


export type MutationCreateMappingReviewArgs = {
  input: CreateMappingReviewInput;
};


export type MutationCreateMembershipArgs = {
  input: CreateMembershipInput;
};


export type MutationCreatePrizeDrawArgs = {
  autoFulfilOnAccept?: InputMaybe<Scalars['Boolean']['input']>;
  autoSendWinnerEmails?: InputMaybe<Scalars['Boolean']['input']>;
  boxIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  end?: InputMaybe<Scalars['String']['input']>;
  eventIds?: InputMaybe<Array<Scalars['String']['input']>>;
  gameId: Scalars['String']['input'];
  prizeType: PrizeType;
  scheduledAt?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  surveyType?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: PrizeDrawType;
  winnersCount: Scalars['Int']['input'];
  winnersDistribution?: InputMaybe<WinnersDistributionInput>;
};


export type MutationCreateRoleArgs = {
  input: CreateAdminRoleInput;
};


export type MutationCreateTagGlobalArgs = {
  input: TagGlobalRangeCreateInput;
};


export type MutationCreateTagRangeArgs = {
  input: GameTagRangeCreateInput;
};


export type MutationCreateTagSubrangeArgs = {
  input: GameTagSubrangeCreateInput;
};


export type MutationCreateTeamArgs = {
  input: TeamCreateInput;
};


export type MutationDeleteAdminArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCampaignArgs = {
  campaignId: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
};


export type MutationDeleteEventArgs = {
  input: DeleteEvent;
};


export type MutationDeleteEventPointArgs = {
  input: DeleteEventPoint;
};


export type MutationDeleteGameArgs = {
  input: DeleteGameInput;
};


export type MutationDeleteLeaderboardArgs = {
  input: DeleteLeaderboard;
};


export type MutationDeleteMapDatasetArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteMappingGroupArgs = {
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationDeleteMappingGroupElementArgs = {
  input: GroupElementInput;
};


export type MutationDeleteMappingLocationArgs = {
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationDeleteMappingReviewerArgs = {
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationDeleteMembershipArgs = {
  input: DeleteMembershipInput;
};


export type MutationDeletePlayerArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePrizeDrawArgs = {
  drawId: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
};


export type MutationDeletePrizeDrawWinnerArgs = {
  drawId: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type MutationDeleteRoleArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTagGlobalArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTagRangeArgs = {
  input: GameTagRangeDeleteInput;
};


export type MutationDeleteTagSubrangeArgs = {
  input: GameTagSubrangeDeleteInput;
};


export type MutationDeleteTeamArgs = {
  input: TeamDeleteInput;
};


export type MutationDrawMorePrizeDrawWinnersArgs = {
  drawId: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
  winnersCount: Scalars['Int']['input'];
  winnersDistribution?: InputMaybe<WinnersDistributionInput>;
};


export type MutationDuplicateEventArgs = {
  input: GetEvent;
};


export type MutationGenerateGameResourcePdfArgs = {
  input: GenerateGameResourcePdfInput;
};


export type MutationGetSurveyLinkArgs = {
  input: AdminGetSurveyLink;
};


export type MutationImportMapDatasetArgs = {
  input: ImportMapDatasetInput;
};


export type MutationInstallerUpdateLocationArgs = {
  input: InstallerLocationUpdateInput;
};


export type MutationInviteMappingReviewerArgs = {
  input: InviteMappingReviewerInput;
};


export type MutationIsGameRangeAvailableArgs = {
  input: IsGameTagRangeAvailable;
};


export type MutationIsSubrangeAvailableArgs = {
  input: IsTagSubrangesAvailable;
};


export type MutationJoinTeamArgs = {
  input: JoinTeamInput;
};


export type MutationKickFromGameArgs = {
  id: Scalars['String']['input'];
};


export type MutationLeaveTeamArgs = {
  playerId: Scalars['String']['input'];
};


export type MutationLinkMapDatasetArgs = {
  input: LinkMapDatasetInput;
};


export type MutationMapDatasetUploadUrlArgs = {
  input: MapDatasetUploadTargetInput;
};


export type MutationMarkPrizeDrawWinnerAsFulfilledArgs = {
  drawId: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type MutationMoveSmallTeamsArgs = {
  input: MoveSmallTeamsInput;
};


export type MutationMoveTagArgs = {
  input: MovePlayerInput;
};


export type MutationPublishMappingGameArgs = {
  gameId: Scalars['String']['input'];
  layers?: InputMaybe<Array<MappingLayer>>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationPublishMappingLocationArgs = {
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationRefreshMapDatasetArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveInactiveTagArgs = {
  input: InactiveTagDeleteInput;
};


export type MutationRemovePlayersFromGameArgs = {
  gameId: Scalars['String']['input'];
};


export type MutationResolveMappingCommentArgs = {
  input: ResolveMappingCommentInput;
};


export type MutationReviewerApproveMappingLayerArgs = {
  input: ApproveMappingLayerInput;
};


export type MutationReviewerCreateMappingCommentArgs = {
  input: CreateMappingCommentInput;
};


export type MutationReviewerResolveMappingCommentArgs = {
  input: ResolveMappingCommentInput;
};


export type MutationReviewerToggleMappingCommentReactionArgs = {
  input: ToggleMappingCommentReactionInput;
};


export type MutationReviewerUpdateMappingCommentArgs = {
  input: UpdateMappingCommentInput;
};


export type MutationReviewerUpdateMappingReviewArgs = {
  input: UpdateMappingReviewInput;
};


export type MutationSearchSurveysArgs = {
  input: AdminSearchSurveys;
};


export type MutationSendPrizeDrawWinnerEmailArgs = {
  drawId: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type MutationStartDataExportArgs = {
  input: StartDataExportInput;
};


export type MutationStartOrsRuntimeArgs = {
  input: StartOrsRuntimeInput;
};


export type MutationSubmitMappingLayerForReviewArgs = {
  input: SubmitMappingLayerForReviewInput;
};


export type MutationSubmitMappingStageArgs = {
  input: SubmitMappingStageInput;
};


export type MutationToggleMappingCommentReactionArgs = {
  input: ToggleMappingCommentReactionInput;
};


export type MutationUnlinkMapDatasetArgs = {
  input: UnlinkMapDatasetInput;
};


export type MutationUnlockApprovedTagSubrangeArgs = {
  input: GameTagSubrangeDeleteInput;
};


export type MutationUpdateAdminArgs = {
  input: UpdateAdminInput;
};


export type MutationUpdateCampaignArgs = {
  input: UpdateCampaignInput;
};


export type MutationUpdateEventArgs = {
  input: EventUpdateInput;
};


export type MutationUpdateGameArgs = {
  input: UpdateGameInput;
};


export type MutationUpdateGameMapDatasetArgs = {
  input: UpdateGameMapDatasetInput;
};


export type MutationUpdateLeaderboardArgs = {
  input: GameLeaderboardUpdateInput;
};


export type MutationUpdateMapDatasetArgs = {
  input: UpdateMapDatasetInput;
};


export type MutationUpdateMappingCommentArgs = {
  input: UpdateMappingCommentInput;
};


export type MutationUpdateMappingGroupArgs = {
  input: UpdateGroupInput;
};


export type MutationUpdateMappingLocationArgs = {
  input: UpdateMappingLocationInput;
};


export type MutationUpdateMappingReviewArgs = {
  input: UpdateMappingReviewInput;
};


export type MutationUpdateMembershipArgs = {
  input: UpdateMembershipInput;
};


export type MutationUpdateMyProfileArgs = {
  fullName: Scalars['String']['input'];
};


export type MutationUpdatePlayerArgs = {
  input: FullUpdatePlayerInput;
};


export type MutationUpdatePlayerPointsArgs = {
  input: IncrementPlayerPoint;
};


export type MutationUpdateRoleArgs = {
  input: UpdateAdminRoleInput;
};


export type MutationUpdateTagGlobalArgs = {
  input: TagGlobalRangeUpdateInput;
};


export type MutationUpdateTagRangeArgs = {
  input: GameTagRangeUpdateInput;
};


export type MutationUpdateTagSubrangeArgs = {
  input: GameTagSubrangeUpdateInput;
};


export type MutationUpdateTeamArgs = {
  input: TeamUpdateInput;
};


export type MutationValidateSurveyArgs = {
  input: AdminValidateSurvey;
};

/** Nearby OS NGD lamppost candidates for a rough Beat Box point */
export type NearbyLamppostsResult = {
  candidates: Array<LamppostCandidate>;
  /** Search radius (m) that produced this candidate set */
  searchRadiusMeters: Scalars['Int']['output'];
};

/** Orders tag types (only card used) */
export enum OrderTagTypes {
  Card = 'CARD'
}

export type OrsRuntimeArtifactCountry = {
  artifacts: Array<OrsRuntimeArtifactOption>;
  countryKey: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
};

export type OrsRuntimeArtifactOption = {
  artifactPath: Scalars['String']['output'];
  countryKey: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
};

export type OrsRuntimeStatus = {
  artifactKey?: Maybe<Scalars['String']['output']>;
  artifactPath?: Maybe<Scalars['String']['output']>;
  autoScalingGroupName: Scalars['String']['output'];
  configS3Uri?: Maybe<Scalars['String']['output']>;
  currentCapacity: Scalars['Int']['output'];
  desiredCapacity: Scalars['Int']['output'];
  instanceId?: Maybe<Scalars['String']['output']>;
  instanceState?: Maybe<Scalars['String']['output']>;
  manifestCreatedAt?: Maybe<Scalars['String']['output']>;
  orsHealthStatus: Scalars['String']['output'];
  scheduledStopAt?: Maybe<Scalars['String']['output']>;
};

export type OrsRuntimeStopResult = {
  autoScalingGroupName: Scalars['String']['output'];
  desiredCapacity: Scalars['Int']['output'];
};

/** Overlap information for subrange conflicts */
export type OverlapInfo = {
  gameId: Scalars['String']['output'];
  gameName: Scalars['String']['output'];
  isSameGame: Scalars['Boolean']['output'];
};

export type PdfGenerationJob = {
  createdAt: Scalars['String']['output'];
  downloadUrl?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  gameId: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  resourceKey: GameResourceKey;
  s3Path: Scalars['String']['output'];
  status: PdfGenerationStatus;
  templateId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum PdfGenerationStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY',
  Running = 'RUNNING'
}

export type Player = {
  /** Only for local sign up purpose */
  authID?: Maybe<Scalars['String']['output']>;
  /** Cognito email_verified for player pool user; null if no auth user (e.g. child) */
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  game?: Maybe<PlayerGame>;
  gemRoutes?: Maybe<Array<GemRoute>>;
  id: Scalars['String']['output'];
  info: PlayerInfo;
  points?: Maybe<PlayerPoint>;
  profile: PlayerProfile;
  role: PlayerRole;
  routes?: Maybe<Array<Route>>;
  tags: Array<PlayerTag>;
  team?: Maybe<Team>;
};

export type PlayerGame = {
  consentAt?: Maybe<Scalars['String']['output']>;
  consentText?: Maybe<Scalars['String']['output']>;
  gameId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  joinedAt?: Maybe<Scalars['String']['output']>;
  leaveAt?: Maybe<Scalars['String']['output']>;
  playerId: Scalars['String']['output'];
};

export type PlayerInfo = {
  /** Reference to mobile avatar. ex.: character13 */
  avatar?: Maybe<Scalars['String']['output']>;
  gameId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  publicName?: Maybe<Scalars['String']['output']>;
  secondaryTeamId?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['String']['output']>;
};

/** Update Player Info */
export type PlayerInfoInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
};

export type PlayerPoint = {
  /** Sum of routes and extra */
  all: Scalars['Float']['output'];
  extra: Scalars['Float']['output'];
  gems: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  mileage?: Maybe<Scalars['Float']['output']>;
  /** Points for beatbox */
  routes: Scalars['Float']['output'];
};

export type PlayerProfile = {
  /** Only for children */
  ageGroup?: Maybe<Scalars['String']['output']>;
  /** Player subscript to marketing email */
  allowMarketingEmails?: Maybe<Scalars['Boolean']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  birthYear?: Maybe<Scalars['Float']['output']>;
  /** PLayer sign consent text. */
  consentText?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  /** The timestamp that the user was deleted as part of data-retention process */
  deletedAt?: Maybe<Scalars['Float']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  genderIdentity?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imdFormattedPostCode?: Maybe<Scalars['String']['output']>;
  /** Indicates if player completed all info */
  isRegistered?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use Player.emailVerified instead */
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No longer needed. TO REMOVE */
  lastName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favor of zoneId */
  lsoaCode?: Maybe<Scalars['String']['output']>;
  /** Marketing email consent text */
  marketingEmailsText?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer needed. TO REMOVE */
  mobileNumber?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  zoneId?: Maybe<Scalars['String']['output']>;
  zoneType?: Maybe<ZoneType>;
};

/** Update Player Profile */
export type PlayerProfileInput = {
  allowMarketingEmails?: InputMaybe<Scalars['Boolean']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  birthYear?: InputMaybe<Scalars['Float']['input']>;
  consentText?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  genderIdentity?: InputMaybe<Scalars['String']['input']>;
  isRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketingEmailsText?: InputMaybe<Scalars['String']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
};

export type PlayerRole = {
  authID?: Maybe<Scalars['String']['output']>;
  /** True for unregistered players */
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
  isChild?: Maybe<Scalars['Boolean']['output']>;
  /** Same as playerId for adults */
  parentId?: Maybe<Scalars['String']['output']>;
  removedAt?: Maybe<Scalars['String']['output']>;
};

export type PlayerTag = {
  code?: Maybe<Scalars['String']['output']>;
  deviceID?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  playerId: Scalars['String']['output'];
  tagNumber: Scalars['Int']['output'];
  tagType: TagTypes;
};

/** Create Player Tag */
export type PlayerTagCreateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  deviceID?: InputMaybe<Scalars['String']['input']>;
  playerId: Scalars['String']['input'];
  tagNumber?: InputMaybe<Scalars['Int']['input']>;
  tagType: TagTypes;
};

export type PlayersList = {
  all: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
};

export type PlayersListInput = {
  gameId: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['String']['input']>;
};

/** Derived status reflecting the next required admin action */
export enum PrizeDrawDisplayStatus {
  /** Winners notified and awaiting their response */
  AwaitingResponses = 'AwaitingResponses',
  /** All winners resolved or fulfilment is automatic */
  Complete = 'Complete',
  /** Draw failed or could not complete */
  Failed = 'Failed',
  /** Some winner notifications failed to send */
  NeedsAttention = 'NeedsAttention',
  /** Winners accepted and awaiting manual fulfilment */
  NeedsFulfilment = 'NeedsFulfilment',
  /** Draw has run but no winners were drawn */
  NoWinners = 'NoWinners',
  /** Draw has not run yet */
  Scheduled = 'Scheduled'
}

export type PrizeDrawRecord = {
  autoFulfilOnAccept?: Maybe<Scalars['Boolean']['output']>;
  autoSendWinnerEmails?: Maybe<Scalars['Boolean']['output']>;
  boxIds?: Maybe<Array<Scalars['String']['output']>>;
  description: Scalars['String']['output'];
  displayStatus?: Maybe<PrizeDrawDisplayStatus>;
  drawId: Scalars['String']['output'];
  end?: Maybe<Scalars['String']['output']>;
  eventIds?: Maybe<Array<Scalars['String']['output']>>;
  gameId: Scalars['String']['output'];
  prizeType: PrizeType;
  scheduledAt?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
  status: PrizeDrawStatus;
  surveyType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: PrizeDrawType;
  winnersCount: Scalars['Int']['output'];
  winnersDistribution?: Maybe<WinnersDistribution>;
  winnersDrawn?: Maybe<Scalars['Int']['output']>;
};

/** Prize draw status */
export enum PrizeDrawStatus {
  /** Prize draw has been created and waiting for winners to be drawn */
  Created = 'Created',
  /** Prize draw has been deleted and is no longer visible */
  Deleted = 'Deleted',
  /** Prize draw has been drawn and winners are selected */
  Drawn = 'Drawn',
  /** Prize draw has failed to be drawn */
  Failed = 'Failed',
  /** Prize draw has been scheduled and will run automatically at a future time */
  Scheduled = 'Scheduled'
}

/** Prize draw type - how the winners are selected */
export enum PrizeDrawType {
  Event = 'Event',
  Survey = 'Survey',
  Time = 'Time'
}

/** Prize draw winner status */
export enum PrizeDrawWinnerStatus {
  /** Winner has accepted the prize */
  Accepted = 'Accepted',
  /** Winner has been removed from the draw */
  Deleted = 'Deleted',
  /** Winner has been drawn and is awaiting email notification */
  Drawn = 'Drawn',
  /** Winner has been notified via email */
  Emailed = 'Emailed',
  /** Prize acceptance has expired */
  Expired = 'Expired',
  /** Winner notification failed */
  Failed = 'Failed',
  /** Prize has been delivered/fulfilled */
  Fulfilled = 'Fulfilled',
  /** Winner has rejected the prize */
  Rejected = 'Rejected'
}

/** Prize type - physical or digital */
export enum PrizeType {
  Digital = 'Digital',
  Physical = 'Physical'
}

export type Query = {
  /** Server-computed Beat Box placement preview for a mapping game (snap, isochrone, nearest, too-close) */
  assessMappingPlacement: LocationPlacementAssessment;
  findAllGroupsElements: Array<GroupElement>;
  findDataExportJobs: Array<DataExportJob>;
  findEventPoints: Array<EventPoint>;
  findEvents: Array<Event>;
  findFamilyPlayers: Array<Player>;
  findGameResources: Array<GameResource>;
  findGroupElements: Array<GroupElement>;
  findGroups: Array<Group>;
  findInactiveTags: Array<InactiveTag>;
  findLeaderboards: Array<GameLeaderboard>;
  findLocations: Array<Location>;
  findMemberships: Array<AdminMembership>;
  findPdfGenerationJobs: Array<PdfGenerationJob>;
  findPlayerList: Array<PlayersList>;
  findPlayerSurveys: Array<Survey>;
  findPlayers: Array<Player>;
  findSwipeByDateRange: Array<Swipe>;
  findSwipeByTag: Array<Swipe>;
  findTagByType: Array<PlayerTag>;
  findTagGlobal: Array<TagGlobalRange>;
  findTagRanges: Array<GameTagRange>;
  findTagSubranges: Array<GameTagSubrange>;
  findTeamNames: TeamNames;
  findTeams: Array<Team>;
  gameAggregates: AnalyticsGameResult;
  gameMapDatasets: Array<GameMapDataset>;
  getAdmin?: Maybe<Admin>;
  getCampaigns: Array<CampaignRecord>;
  getDataExportJob: DataExportJob;
  getEvent: Event;
  getGame: Game;
  getGameBySlug: Game;
  getGroup: Group;
  getLeaderboard: GameLeaderboard;
  getLocation: Location;
  getMembership?: Maybe<AdminMembership>;
  getPdfGenerationJob: PdfGenerationJob;
  getPlayer: Player;
  getPlayerBy: Player;
  getPlayerByAuth: Player;
  getPlayerByEmail: Player;
  getPlayerLeaderboards: LeaderboardsResponse;
  getPlayerLuckySwipes: Array<Swipe>;
  getPlayersForPaginatedList: Array<Player>;
  getPrizeDraw: PrizeDrawRecord;
  getPrizeDrawWinner: EnrichedPrizeDrawWinner;
  getRole: AdminRole;
  getTagByTagNumber?: Maybe<PlayerTag>;
  getTagGlobal: TagGlobalRange;
  getTagRange: GameTagRange;
  getTagSubrange: GameTagSubrange;
  getTeam: Team;
  hour2Aggregates: Array<AnalyticsHour2Result>;
  imdDecileAggregates: ImdDecileAggregates;
  installerFindLocations: Array<Location>;
  installerFindSwipeByTag: Array<Swipe>;
  listAdmins: Array<Admin>;
  listGames: Array<Game>;
  listLuckySwipes: Array<Swipe>;
  listPrizeDrawWinners: Array<EnrichedPrizeDrawWinner>;
  listPrizeDraws: Array<PrizeDrawRecord>;
  listRoles: Array<AdminRole>;
  locationAggregates: Array<AnalyticsLocationResult>;
  mapDataset: MapDataset;
  mapDatasets: Array<MapDataset>;
  /** Every comment in the game, review threads and queries alike, whatever their status */
  mappingComments: Array<MappingComment>;
  /** Moves on every mapping write in the game: poll it, and refetch the rest when it changes */
  mappingGameRevision: Scalars['Int']['output'];
  mappingGroupElements: Array<GroupElement>;
  mappingGroups: Array<Group>;
  mappingLayerReviews: Array<MappingLayerReview>;
  mappingLocation: MappingLocation;
  mappingLocationHistory: Array<MappingHistory>;
  mappingLocations: Array<MappingLocation>;
  mappingReview: MappingReview;
  mappingReviewers: Array<MappingReviewer>;
  mappingReviews: Array<MappingReview>;
  /** The map's stage and its review rounds */
  mappingWorkflow: MappingWorkflow;
  me?: Maybe<Admin>;
  namedCounterAggregates: Array<AnalyticsNamedCounterResult>;
  /** OS NGD street lights near a rough Beat Box point for mapping workflow. */
  nearbyMappingLampposts: NearbyLamppostsResult;
  orsRuntimeArtifactGroups: Array<OrsRuntimeArtifactCountry>;
  orsRuntimeStatus: OrsRuntimeStatus;
  /** Every comment with this reviewer, review threads and queries alike, closed ones included */
  reviewerMappingComments: Array<MappingComment>;
  reviewerMappingLayerReviews: Array<MappingLayerReview>;
  reviewerMappingLocation: MappingLocation;
  reviewerMappingLocationHistory: Array<MappingHistory>;
  reviewerMappingLocations: Array<ReviewerMappingLocationEntry>;
  reviewerMappingReviews: Array<MappingReview>;
  /** Moves on every mapping write in the reviewer's game: poll it, and refetch the rest when it changes */
  reviewerMappingRevision: Scalars['Int']['output'];
  reviewerMe: ReviewerMe;
  zoneAggregates: Array<AnalyticsZoneResult>;
};


export type QueryAssessMappingPlacementArgs = {
  gameId: Scalars['String']['input'];
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  selfId?: InputMaybe<Scalars['String']['input']>;
  snap?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFindAllGroupsElementsArgs = {
  gameId: Scalars['String']['input'];
};


export type QueryFindDataExportJobsArgs = {
  gameId: Scalars['String']['input'];
};


export type QueryFindEventPointsArgs = {
  input: FindEventPoints;
};


export type QueryFindEventsArgs = {
  gameId: Scalars['String']['input'];
};


export type QueryFindFamilyPlayersArgs = {
  input: FindFamilyPlayersInput;
};


export type QueryFindGameResourcesArgs = {
  gameId: Scalars['String']['input'];
};


export type QueryFindGroupElementsArgs = {
  input: FindGroupElements;
};


export type QueryFindGroupsArgs = {
  gameId: Scalars['String']['input'];
};


export type QueryFindInactiveTagsArgs = {
  input: FindInactiveTagInput;
};


export type QueryFindLeaderboardsArgs = {
  gameId: Scalars['String']['input'];
};


export type QueryFindLocationsArgs = {
  gameId: Scalars['String']['input'];
};


export type QueryFindMembershipsArgs = {
  input: FindMembershipsInput;
};


export type QueryFindPdfGenerationJobsArgs = {
  gameId: Scalars['String']['input'];
};


export type QueryFindPlayerListArgs = {
  input: PlayersListInput;
};


export type QueryFindPlayerSurveysArgs = {
  gameId: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type QueryFindPlayersArgs = {
  gameId: Scalars['String']['input'];
  secondaryTeamId?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindSwipeByDateRangeArgs = {
  input: FindSwipeByDateRange;
};


export type QueryFindSwipeByTagArgs = {
  input: FindByTag;
};


export type QueryFindTagByTypeArgs = {
  type: TagTypes;
};


export type QueryFindTagRangesArgs = {
  gameId: Scalars['String']['input'];
};


export type QueryFindTagSubrangesArgs = {
  input: FindTagSubranges;
};


export type QueryFindTeamNamesArgs = {
  input: FindTeamsInput;
};


export type QueryFindTeamsArgs = {
  input: FindTeamsInput;
};


export type QueryGameAggregatesArgs = {
  gameId: Scalars['String']['input'];
  metric: AnalyticsMetric;
};


export type QueryGameMapDatasetsArgs = {
  gameId: Scalars['String']['input'];
};


export type QueryGetAdminArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetCampaignsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  gameId: Scalars['String']['input'];
};


export type QueryGetDataExportJobArgs = {
  gameId: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
};


export type QueryGetEventArgs = {
  input: GetEvent;
};


export type QueryGetGameArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetGameBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGetGroupArgs = {
  input: GetGroup;
};


export type QueryGetLeaderboardArgs = {
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryGetLocationArgs = {
  input: GetLocationInput;
};


export type QueryGetMembershipArgs = {
  adminId: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
};


export type QueryGetPdfGenerationJobArgs = {
  gameId: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
};


export type QueryGetPlayerArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetPlayerByArgs = {
  input: SearchPlayerByInput;
};


export type QueryGetPlayerByAuthArgs = {
  authID: Scalars['String']['input'];
};


export type QueryGetPlayerByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetPlayerLeaderboardsArgs = {
  input: GetPlayerLeaderboardsInput;
};


export type QueryGetPlayerLuckySwipesArgs = {
  gameId: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type QueryGetPlayersForPaginatedListArgs = {
  input: GetForPaginatedListInput;
};


export type QueryGetPrizeDrawArgs = {
  drawId: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
};


export type QueryGetPrizeDrawWinnerArgs = {
  drawId: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type QueryGetRoleArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetTagByTagNumberArgs = {
  tagNumber: Scalars['Int']['input'];
};


export type QueryGetTagGlobalArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetTagRangeArgs = {
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryGetTagSubrangeArgs = {
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryGetTeamArgs = {
  input: GetTeamInput;
};


export type QueryHour2AggregatesArgs = {
  gameId: Scalars['String']['input'];
  hour2Buckets: Array<Scalars['String']['input']>;
  metric: AnalyticsMetric;
};


export type QueryImdDecileAggregatesArgs = {
  gameId: Scalars['String']['input'];
};


export type QueryInstallerFindLocationsArgs = {
  gameId: Scalars['String']['input'];
};


export type QueryInstallerFindSwipeByTagArgs = {
  input: FindByTag;
};


export type QueryListLuckySwipesArgs = {
  gameId: Scalars['String']['input'];
};


export type QueryListPrizeDrawWinnersArgs = {
  drawId: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryListPrizeDrawsArgs = {
  gameId: Scalars['String']['input'];
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLocationAggregatesArgs = {
  gameId: Scalars['String']['input'];
  locationIds: Array<Scalars['ID']['input']>;
  metric: AnalyticsMetric;
};


export type QueryMapDatasetArgs = {
  id: Scalars['String']['input'];
};


export type QueryMappingCommentsArgs = {
  gameId: Scalars['String']['input'];
};


export type QueryMappingGameRevisionArgs = {
  gameId: Scalars['String']['input'];
};


export type QueryMappingGroupElementsArgs = {
  gameId: Scalars['String']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMappingGroupsArgs = {
  gameId: Scalars['String']['input'];
};


export type QueryMappingLayerReviewsArgs = {
  gameId: Scalars['String']['input'];
  type: MappingReviewType;
};


export type QueryMappingLocationArgs = {
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryMappingLocationHistoryArgs = {
  gameId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};


export type QueryMappingLocationsArgs = {
  gameId: Scalars['String']['input'];
};


export type QueryMappingReviewArgs = {
  gameId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  type: MappingReviewType;
};


export type QueryMappingReviewersArgs = {
  gameId: Scalars['String']['input'];
};


export type QueryMappingReviewsArgs = {
  gameId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};


export type QueryMappingWorkflowArgs = {
  gameId: Scalars['String']['input'];
};


export type QueryNamedCounterAggregatesArgs = {
  bucketNames: Array<Scalars['String']['input']>;
  counterName: AnalyticsNamedCounterName;
  gameId: Scalars['String']['input'];
};


export type QueryNearbyMappingLamppostsArgs = {
  gameId: Scalars['String']['input'];
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};


export type QueryReviewerMappingLocationArgs = {
  id: Scalars['String']['input'];
};


export type QueryReviewerMappingLocationHistoryArgs = {
  locationId: Scalars['String']['input'];
};


export type QueryReviewerMappingLocationsArgs = {
  layer?: InputMaybe<MappingLayer>;
};


export type QueryReviewerMappingReviewsArgs = {
  locationId: Scalars['String']['input'];
};


export type QueryZoneAggregatesArgs = {
  filter?: InputMaybe<AnalyticsFilterInput>;
  gameId: Scalars['String']['input'];
  metric: AnalyticsMetric;
  zoneIds: Array<Scalars['String']['input']>;
};

export type ResolveMappingCommentInput = {
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type ReviewerMappingLocationEntry = {
  location: MappingLocation;
  review: MappingReview;
};

export type ReviewerMe = {
  allowedReviewType: MappingReviewerType;
  email: Scalars['String']['output'];
  gameId: Scalars['String']['output'];
  gameName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** The game's name for its POI layer, when it has overridden the default. */
  poiName?: Maybe<Scalars['String']['output']>;
};

export type Route = {
  gameId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  locationSlug?: Maybe<Scalars['String']['output']>;
  playerId: Scalars['String']['output'];
  points: Scalars['Int']['output'];
  swipeId: Scalars['String']['output'];
  swipeTimestamp: Scalars['String']['output'];
  tagNumber: Scalars['Int']['output'];
};

export type SearchPlayerByInput = {
  gameId?: InputMaybe<Scalars['String']['input']>;
  type: SearchType;
  value: Scalars['String']['input'];
};

export type SearchSurveyResult = {
  dateCreated?: Maybe<Scalars['String']['output']>;
  dateModified?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** Option type for players search */
export enum SearchType {
  Email = 'email',
  PlayerId = 'playerId',
  PublicName = 'publicName',
  TagNumber = 'tagNumber'
}

export type Settings = {
  POIName?: Maybe<Scalars['String']['output']>;
  beatBoxPlacementValidationEnabled?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer used. Player API always returns true for released mobile clients. */
  collectGenderAsSex?: Maybe<Scalars['Boolean']['output']>;
  collectPartnerConsentForAges13To17?: Maybe<Scalars['Boolean']['output']>;
  defaultPoints: Scalars['Int']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  locationDistance: Scalars['Float']['output'];
  locationDistanceMeters: Scalars['Int']['output'];
  lon?: Maybe<Scalars['Float']['output']>;
  luckyTapEnabled?: Maybe<Scalars['Boolean']['output']>;
  luckyTapFrequency?: Maybe<Scalars['Int']['output']>;
  luckyTapPoints?: Maybe<Scalars['Int']['output']>;
  /** Off: a map skips every review gate and publishes without sign-off. Unset reads as on. */
  mappingApprovalsRequired?: Maybe<Scalars['Boolean']['output']>;
  /** On: every standard Beat Box needs a post before it is published. Unset reads as on. */
  mappingPostRequired?: Maybe<Scalars['Boolean']['output']>;
  maxSwipeTime: Scalars['Int']['output'];
  minSwipeTime: Scalars['Int']['output'];
  target: Scalars['Int']['output'];
  /** How many standard Beat Boxes the map is planned to have */
  targetBeatBoxCount?: Maybe<Scalars['Int']['output']>;
  targetZones?: Maybe<Array<Scalars['String']['output']>>;
  timezone: Scalars['String']['output'];
};

export type SettingsInput = {
  POIName?: InputMaybe<Scalars['String']['input']>;
  beatBoxPlacementValidationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  collectPartnerConsentForAges13To17?: InputMaybe<Scalars['Boolean']['input']>;
  defaultPoints?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  locationDistanceMeters?: InputMaybe<Scalars['Int']['input']>;
  lon?: InputMaybe<Scalars['Float']['input']>;
  luckyTapEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  luckyTapFrequency?: InputMaybe<Scalars['Int']['input']>;
  luckyTapPoints?: InputMaybe<Scalars['Int']['input']>;
  mappingApprovalsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  mappingPostRequired?: InputMaybe<Scalars['Boolean']['input']>;
  maxSwipeTime?: InputMaybe<Scalars['Int']['input']>;
  minSwipeTime?: InputMaybe<Scalars['Int']['input']>;
  target?: InputMaybe<Scalars['Int']['input']>;
  targetBeatBoxCount?: InputMaybe<Scalars['Int']['input']>;
  targetZones?: InputMaybe<Array<Scalars['String']['input']>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Details of a skipped range assignment */
export type SkippedRange = {
  conflictingGame?: Maybe<ConflictingGame>;
  range: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  subrangeId: Scalars['String']['output'];
};

export type SortKeyBoolean = {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SortKeyNumber = {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  ge?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  le?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
};

export type StartDataExportInput = {
  exportType: DataExportType;
  gameId: Scalars['String']['input'];
  /** Player IDs to look up, used by the emailExtractor export */
  playerIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StartOrsRuntimeInput = {
  artifactPath: Scalars['String']['input'];
  nonExpiring?: InputMaybe<Scalars['Boolean']['input']>;
  timeoutMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type SubmitMappingLayerForReviewInput = {
  gameId: Scalars['String']['input'];
  layer: MappingLayer;
  type: MappingReviewType;
};

export type SubmitMappingStageInput = {
  gameId: Scalars['String']['input'];
  /** Sign-off layers to send with a client round */
  layers?: InputMaybe<Array<MappingLayer>>;
  /** Narrows the Beat Boxes sent, to retry the ones that failed */
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The gate to send Beat Boxes to: the map's open round, or the one after it */
  type: MappingReviewType;
};

export type SubrangeFilter = {
  from?: InputMaybe<SortKeyNumber>;
  isApproved?: InputMaybe<SortKeyBoolean>;
  isLocked?: InputMaybe<SortKeyBoolean>;
  to?: InputMaybe<SortKeyNumber>;
};

/** Result of subrange availability check */
export type SubrangeOverlapResult = {
  isAvailable: Scalars['Boolean']['output'];
  overlap?: Maybe<OverlapInfo>;
};

/** Game sub-ranges types */
export enum SubrangesTypes {
  Custom = 'custom',
  DistributionPoint = 'distributionPoint',
  LocalTeamSpares = 'localTeamSpares',
  Team = 'team'
}

export type Survey = {
  active?: Maybe<Scalars['String']['output']>;
  bame?: Maybe<AnswerType>;
  condition?: Maybe<AnswerType>;
  confirmedDate: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  disability?: Maybe<AnswerType>;
  gameId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isChild?: Maybe<Scalars['Boolean']['output']>;
  isConfirmed: Scalars['Boolean']['output'];
  lastResponseId: Scalars['String']['output'];
  playerId: Scalars['String']['output'];
  status?: Maybe<SurveyStatus>;
  surveyType: SurveyTypes;
};

export type SurveyDataShared = {
  lastValidated?: Maybe<Scalars['String']['output']>;
  link: Scalars['String']['output'];
  surveyID: Scalars['String']['output'];
  surveyName?: Maybe<Scalars['String']['output']>;
  validationStatus?: Maybe<ValidationStatus>;
};

export type SurveyDataSharedInput = {
  lastValidated?: InputMaybe<Scalars['String']['input']>;
  link: Scalars['String']['input'];
  surveyID: Scalars['String']['input'];
  surveyName?: InputMaybe<Scalars['String']['input']>;
  validationStatus?: InputMaybe<ValidationStatus>;
};

export type SurveyOptions = {
  closing?: Maybe<ClosingSurvey>;
  oneYear?: Maybe<AfterGameSurvey>;
  sixMonths?: Maybe<AfterGameSurvey>;
  tellUsAboutYou?: Maybe<SurveyDataShared>;
};

export type SurveyOptionsInput = {
  closing?: InputMaybe<ClosingSurveyInput>;
  oneYear?: InputMaybe<AfterGameSurveyInput>;
  sixMonths?: InputMaybe<AfterGameSurveyInput>;
  tellUsAboutYou?: InputMaybe<SurveyDataSharedInput>;
};

/** The status of the survey response */
export enum SurveyStatus {
  Completed = 'completed',
  Disqualified = 'disqualified',
  Overquota = 'overquota',
  Partial = 'partial'
}

/** Types of surveys */
export enum SurveyTypes {
  Closing = 'closing',
  OneYear = 'oneYear',
  SixMonths = 'sixMonths',
  TellUsAboutYou = 'tellUsAboutYou'
}

export type Swipe = {
  /** @deprecated Use sourceMetadata.controlID instead. */
  controlID?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  extraPoints?: Maybe<Scalars['Int']['output']>;
  gameId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ingestId?: Maybe<Scalars['String']['output']>;
  /** Reason for the swipe status if it is invalid */
  invalidationReason?: Maybe<Scalars['String']['output']>;
  isLucky?: Maybe<Scalars['Boolean']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use invalidationReason instead. */
  reason?: Maybe<Scalars['String']['output']>;
  sourceMetadata?: Maybe<Scalars['JSON']['output']>;
  status: SwipeStatus;
  swipeId?: Maybe<Scalars['String']['output']>;
  tagNumber: Scalars['Int']['output'];
  timestamp: Scalars['String']['output'];
  /** @deprecated Use sourceMetadata.wtuLat instead. */
  wtuLat?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use sourceMetadata.wtuLng instead. */
  wtuLng?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use sourceMetadata.wtuSequence instead. */
  wtuSequence?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use sourceMetadata.wtuSerial instead. */
  wtuSerial?: Maybe<Scalars['Int']['output']>;
};

/** SwipeStatus */
export enum SwipeStatus {
  Duplicated = 'duplicated',
  Handled = 'handled',
  Init = 'init',
  Invalid = 'invalid',
  Unknown = 'unknown'
}

export type TagGlobalRange = {
  createdAt: Scalars['String']['output'];
  deliveryDate?: Maybe<Scalars['String']['output']>;
  end: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
  status: CardOrderStatus;
  supplier?: Maybe<Scalars['String']['output']>;
  type: OrderTagTypes;
};

export type TagGlobalRangeCreateInput = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  start: Scalars['Int']['input'];
  status: CardOrderStatus;
  supplier?: InputMaybe<Scalars['String']['input']>;
};

export type TagGlobalRangeUpdateInput = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  start: Scalars['Int']['input'];
  status: CardOrderStatus;
  supplier?: InputMaybe<Scalars['String']['input']>;
};

/** Option type for players to collect points */
export enum TagTypes {
  App = 'app',
  Card = 'card',
  Fob = 'fob'
}

/** Types of tag */
export enum TagsTypes {
  Card = 'card',
  Fob = 'fob'
}

export type TargetedEmailsSetting = {
  gameCountdown: Scalars['Boolean']['output'];
  noActivity: Scalars['Boolean']['output'];
  stoppedPlaying: Scalars['Boolean']['output'];
};

export type TargetedEmailsSettingInput = {
  gameCountdown: Scalars['Boolean']['input'];
  noActivity: Scalars['Boolean']['input'];
  stoppedPlaying: Scalars['Boolean']['input'];
};

export type Team = {
  all: Scalars['Float']['output'];
  /** Team details. Always accessible in resolver. */
  details: TeamDetails;
  extra: Scalars['Float']['output'];
  gameId?: Maybe<Scalars['String']['output']>;
  gems: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  leaderboardId?: Maybe<Scalars['String']['output']>;
  mileage?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  parentTeamId?: Maybe<Scalars['String']['output']>;
  routes: Scalars['Float']['output'];
  status: TeamStatus;
  /** Tag sub-ranges connected to team. Always accessible in resolver. */
  subranges: Array<GameTagSubrange>;
  totalMembers: Scalars['Float']['output'];
  type: TeamTypes;
};

/** Create Team */
export type TeamCreateInput = {
  details: TeamDetailsCreateInput;
  gameId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  leaderboardId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentTeamId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TeamStatus>;
  type: TeamTypes;
};

/** Delete Team */
export type TeamDeleteInput = {
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type TeamDetails = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  leaders?: Maybe<Array<Scalars['String']['output']>>;
  leadersEmails?: Maybe<Array<Scalars['String']['output']>>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  rollNumber?: Maybe<Scalars['Int']['output']>;
};

/** Create Team Details */
export type TeamDetailsCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  gameId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  leaders?: InputMaybe<Array<Scalars['String']['input']>>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  rollNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** Update Team Details */
export type TeamDetailsUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  leaders?: InputMaybe<Array<Scalars['String']['input']>>;
  leadersEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  rollNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type TeamNames = {
  teamNames: Array<Scalars['String']['output']>;
};

/** Team status */
export enum TeamStatus {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected'
}

/** Team types */
export enum TeamTypes {
  SenSchool = 'SENSchool',
  Charity = 'charity',
  Community = 'community',
  Cycling = 'cycling',
  Running = 'running',
  School = 'school',
  Workplace = 'workplace'
}

/** Update Team */
export type TeamUpdateInput = {
  details?: InputMaybe<TeamDetailsUpdateInput>;
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  leaderboardId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentTeamId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TeamStatus>;
  type?: InputMaybe<TeamTypes>;
};

export type Timing = {
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type TimingInput = {
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type ToggleMappingCommentReactionInput = {
  emoji: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type UnlinkMapDatasetInput = {
  datasetId: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
};

export type UpdateAdminInput = {
  adminManagement?: InputMaybe<Scalars['Boolean']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gameCreation?: InputMaybe<Scalars['Boolean']['input']>;
  globalModulesAccess?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  isSuperAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  pii?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAdminRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateCampaignInput = {
  campaignId: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  scheduledTime: Scalars['String']['input'];
};

/** Update Game Info */
export type UpdateGameInfoInput = {
  anticipation?: InputMaybe<Scalars['String']['input']>;
  anticipationStartsAt?: InputMaybe<Scalars['String']['input']>;
  appOnlyGame?: InputMaybe<Scalars['Boolean']['input']>;
  appVariant?: InputMaybe<AppVariant>;
  boundingBox?: InputMaybe<Scalars['String']['input']>;
  endCountdownDays?: InputMaybe<Scalars['Float']['input']>;
  endsAt?: InputMaybe<Scalars['String']['input']>;
  helpWidget?: InputMaybe<HelpWidget>;
  hideOnLanding?: InputMaybe<Scalars['Boolean']['input']>;
  isMobileGame?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<GameRegion>;
  restrictAtDays?: InputMaybe<Scalars['Float']['input']>;
  sanityID?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<SettingsInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GameStatus>;
  surveys?: InputMaybe<SurveyOptionsInput>;
  sustainEndsAt?: InputMaybe<Scalars['String']['input']>;
  targetedEmails?: InputMaybe<TargetedEmailsSettingInput>;
  teamsStartsAt?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<GameType>;
};

/** Update Game */
export type UpdateGameInput = {
  id: Scalars['String']['input'];
  info?: InputMaybe<UpdateGameInfoInput>;
};

export type UpdateGameMapDatasetInput = {
  audience?: InputMaybe<MapDatasetAudience>;
  datasetId: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  styleOverride?: InputMaybe<MapDatasetStyleInput>;
  visibleByDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Update Group */
export type UpdateGroupInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMapDatasetInput = {
  category?: InputMaybe<MapDatasetCategory>;
  defaultStyle?: InputMaybe<MapDatasetStyleInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMappingCommentInput = {
  content: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type UpdateMappingLocationInput = {
  accessible?: InputMaybe<Scalars['Boolean']['input']>;
  beatBoxNumber?: InputMaybe<Scalars['Int']['input']>;
  candidates?: InputMaybe<Array<MappingLocationCandidateInput>>;
  coordinates?: InputMaybe<MappingCoordinatesInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  gameId: Scalars['String']['input'];
  gemType?: InputMaybe<GemType>;
  geo?: InputMaybe<MappingLocationGeoInput>;
  id: Scalars['String']['input'];
  isBonus?: InputMaybe<Scalars['Boolean']['input']>;
  mappingNotes?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  selectedCandidateId?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LocationTypes>;
};

export type UpdateMappingReviewInput = {
  gameId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  riskAssessment?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<MappingReviewStatus>;
  type: MappingReviewType;
};

export type UpdateMembershipInput = {
  adminId: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
  roles: Array<Scalars['String']['input']>;
};

export type ValidateAnswers = {
  days: ValidateSurveyAnswer;
  flag: ValidateSurveyAnswer;
  hours: ValidateSurveyAnswer;
  minutes: ValidateSurveyAnswer;
};

export type ValidateExtraQuestions = {
  bame: ValidateSurveyQuestion;
  condition: ValidateSurveyQuestion;
  disability: ValidateSurveyQuestion;
};

export type ValidateQuestions = {
  days: ValidateSurveyQuestion;
  flag: ValidateSurveyQuestion;
  hours: ValidateSurveyQuestion;
  minutes: ValidateSurveyQuestion;
};

export type ValidateSurveyAnswer = {
  errors: Scalars['JSON']['output'];
  status: ValidateSurveyStatus;
};

export type ValidateSurveyQuestion = {
  message: Scalars['String']['output'];
  status: ValidateSurveyStatus;
};

export type ValidateSurveyResponse = {
  adultAnswers: ValidateAnswers;
  adultQuestions: ValidateQuestions;
  childrenAnswers: ValidateAnswers;
  childrenQuestions: ValidateQuestions;
  extraQuestions: ValidateExtraQuestions;
  surveyLink?: Maybe<Scalars['String']['output']>;
  surveyTitle?: Maybe<Scalars['String']['output']>;
};

/** Status of survey validation. */
export enum ValidateSurveyStatus {
  Failed = 'failed',
  Success = 'success'
}

/** Survey validation status */
export enum ValidationStatus {
  Failed = 'failed',
  Unknown = 'unknown',
  Validated = 'validated'
}

export type WinnersDistribution = {
  adult: Scalars['Int']['output'];
  child: Scalars['Int']['output'];
};

export type WinnersDistributionInput = {
  adult: Scalars['Int']['input'];
  child: Scalars['Int']['input'];
};

export enum ZoneType {
  Lsoa = 'LSOA',
  NorthernIrelandDz = 'NORTHERN_IRELAND_DZ',
  ScotlandDz = 'SCOTLAND_DZ'
}
